import { Button } from '@mui/material';

const Test = () => {
  return (
    <div>
      <h1>Test Page</h1>
      <Button>Hello</Button>
    </div>
  );
};

export default Test;
